import { PERMISSION_LEVELS } from '@src/const';
import { dispatch } from '@src/dispatcher';
import { ActionTypes } from '@src/constants/MogamboConstants';

import * as Api from '@src/api';
import { userHasPermission, permissionErrorAlert } from '../_utils';

export function getBotResponses(stepId, callback, languageCode, isSuperman) {
  if (!userHasPermission(PERMISSION_LEVELS.MOGAMBO_ALL_VIEW))
    return permissionErrorAlert();
  Api.getBotResponses(stepId, callback, languageCode, isSuperman);
}

export function updateEntities(updatedEntity) {
  if (!userHasPermission(PERMISSION_LEVELS.MOGAMBO_ALL_EDIT)) {
    return permissionErrorAlert('update entity');
  }
  dispatch(ActionTypes.UPDATE_ENTITIES, { data: updatedEntity });
}

export function updateBotResponses(
  botResponses,
  callback,
  dontMarkAsUpdate,
  regenerateTruthTable,
  editedLanguage,
  currentHybridLanguage
) {
  dispatch(ActionTypes.UPDATE_BOT_RESPONSES, {
    data: botResponses,
    callback,
    dontMarkAsUpdate,
    regenerateTruthTable,
    editedLanguage,
    currentHybridLanguage,
  });
}

export function saveBotResponses(
  stepId,
  botResponses,
  callback,
  domainTitle,
  domainId
) {
  if (
    !userHasPermission(PERMISSION_LEVELS.MOGAMBO_ALL_EDIT) &&
    !userHasPermission(PERMISSION_LEVELS.MOGAMBO_BOT_SAYS_EDIT)
  ) {
    callback(true);
    return permissionErrorAlert();
  }
  dispatch(ActionTypes.SAVE_BOT_RESPONSES, {
    message: 'Saving Entities & Bot Responses',
  });

  Api.saveBotResponses(stepId, botResponses, callback, domainTitle, domainId);
}
